import { getConfiguration } from '@chr/common-web-ui-configuration';
import { getAxiosInstance } from '@chr/online-shared-microsite-core';
import { AppConfig } from 'react-app-env';
import { BannerResults } from '../constants/navisphereonline.common.api';

export const getBanners = async (): Promise<BannerResults> =>{
  const axiosInstance = await getAxiosInstance();
  const config = await getConfiguration<AppConfig>();
  const serviceUrl = config.commonApiUri;

  const response = await axiosInstance.get<BannerResults>(`${serviceUrl}/Applications/1/Banners`);

  return response.data;
}